import React from "react"
import { Routes, Route } from "react-router"

// Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout"
import VerticalLayout from "../Layouts/index"
import LegacyLayout from "../Layouts/LegacyLayout"

// routes
import getRoutes from "./allRoutes"
import AuthProtected from "./AuthProtected"

const Index = () => {
  const { authProtectedRoutes, publicRoutes } = getRoutes()

  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route: any, idx: any) => (
            <Route
              path={route.path}
              element={
                <LegacyLayout>
                  <NonAuthLayout>{route.component}</NonAuthLayout>
                </LegacyLayout>
              }
              key={idx}
            />
          ))}
        </Route>

        <Route>
          {authProtectedRoutes.map((route: any, idx: any) => (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                  <LegacyLayout>
                    <VerticalLayout>{route.component}</VerticalLayout>
                  </LegacyLayout>
                </AuthProtected>
              }
              key={idx}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  )
}

export default Index